<template>
  <div>
    <Heading class="product-name" :level="2">
      {{ detailedInstrument.symbol }}
    </Heading>

    <ProductQuotasSection
      v-if="showProductQuotas"
      class="description-section"
      :product-details="productQuotasDetails"
    />

    <section v-if="detailedInstrument.description" class="description-section">
      <Heading class="description-section__title" :level="3">Sobre</Heading>
      <p
        class="description-section__specification"
        v-html="detailedInstrument.description"
      />
    </section>

    <section v-if="detailedInstrument.strategy" class="description-section">
      <Heading class="description-section__title" :level="3">
        Estratégia
      </Heading>
      <p
        class="description-section__specification"
        v-html="detailedInstrument.strategy"
      />
    </section>

    <section class="description-section">
      <Heading class="description-section__title" :level="3">
        Características
      </Heading>
      <ProductCharacteristics :detailed-instrument="detailedInstrument" />
    </section>

    <section v-if="detailedInstrument.documents" class="description-section">
      <Heading class="description-section__title" :level="3">
        Documentos
      </Heading>
      <DownloadList :list="detailedInstrument.documents" />
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IDetailedInstrument } from '@/modules/common/services/http/instrument';

import { Heading } from '@warrenbrasil/nebraska-web';
import { DownloadList } from '@/modules/products/components/DownloadList';
import { ProductQuotasSection } from '@/modules/products/components/ProductQuotasSection';
import { ProductCharacteristics } from '@/modules/products/components/ProductCharacteristics';

@Component({
  components: {
    Heading,
    DownloadList,
    ProductQuotasSection,
    ProductCharacteristics
  }
})
export default class ProductDescriptionDetailed extends Vue {
  @Prop({ type: Boolean, default: false })
  private showProductQuotas!: boolean;

  @Prop({ type: Object, required: true })
  private detailedInstrument!: IDetailedInstrument;

  private get productQuotasDetails() {
    return {
      name: this.detailedInstrument.name,
      apiId: this.detailedInstrument.apiId
    };
  }
}
</script>

<style lang="less" scoped>
.product-name {
  margin-bottom: @size-spacing-x600;
}

.description-section {
  & + & {
    margin-top: @size-spacing-x600;
  }

  &__title {
    margin-bottom: @size-spacing-x300;
  }

  &__specification {
    .text-p-3();
    color: @text-primary;

    /* Esses seletores /deep/ são necessários porque
       temos que dar target em elementos injetados pelo v-html */
    /deep/ h3 {
      margin: @size-spacing-x600 0 @size-spacing-x300;
    }

    /deep/ p + p,
    /deep/ ul {
      margin-top: @size-spacing-x500;
    }

    /deep/ table {
      margin: @size-spacing-x500 auto 0;
    }
  }
}
</style>
